export const ErrorCodes = {
  UnexpectedError: 'שגיאה בלתי צפויה',
  Unauthorized: 'נדרשת התחברות',
  InsufficientPermissions: 'אין הרשאות מספיקות',
  EntityNotFound: 'פריט לא נמצא',
  InvalidInitData: 'נתוני ההתחברות מטלגרם אינם תקינים',
  TooManyAttempts: 'יותר מדי ניסיונות, נסו שוב מאוחר יותר',
  TelegramLoginFailed: 'ההתחברות עם טלגרם נכשלה',
  TelegramLoginNotConfigured: 'התחברות עם טלגרם אינה מוגדרת בשרת',
  InvalidEmail: 'כתובת האימייל אינה תקינה',
  CaptchaFailed: 'האימות "אני לא רובוט" נכשל או פג תוקפו, סמנו שוב',
  EmailNotConfigured: 'שליחת אימייל אינה מוגדרת בשרת',
  EmailSendFailed: 'שליחת הקוד נכשלה, נסו שוב',
  InvalidCode: 'הקוד שגוי או שפג תוקפו',
  InvalidOrder: 'ההזמנה אינה תקינה',
  OutOfStock: 'אחד המוצרים אזל מהמלאי'
} as const;

export type ErrorCodeType = keyof typeof ErrorCodes;
